import { render } from "./widgetActionIcon.vue?vue&type=template&id=d15ed720"
import script from "./widgetActionIcon.vue?vue&type=script&lang=js"
export * from "./widgetActionIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__